import React, { Component } from 'react'

 class Datadiv extends Component {

    

    render() {
        let pricegainloss= !this.props.lastvalue ? '' : (Number(this.props.value[this.props.pairid].lastPrice) < Number(this.props.lastvalue[this.props.pairid].lastPrice) ? 'loss' : 'gain');
        let changegainloss= !this.props.lastvalue ? '' : (Number(this.props.value[this.props.pairid].priceChangePercent) < Number(this.props.lastvalue[this.props.pairid].priceChangePercent) ? 'bgloss' : 'bggain');
        
        return (
                <div  className="desktop dataloaded">
                
                <p className="pair"><strong>{ 
                 ((((this.props.value[this.props.pairid].symbol).length)===6)? 
                 ((this.props.value[this.props.pairid].symbol).substring(0,3)) : 
                 ((((this.props.value[this.props.pairid].symbol).length)===7) ? 
                 ((((this.props.value[this.props.pairid].symbol).substring(4,7))==="BTC")? 
                 ((this.props.value[this.props.pairid].symbol).substring(0,4)) : 
                 ((this.props.value[this.props.pairid].symbol).substring(0,3))) :
                 (
                 ((((this.props.value[this.props.pairid].symbol).length)===8) ? 
                 ((((this.props.value[this.props.pairid].symbol).substring(5,8))==="BTC")? 
                 ((this.props.value[this.props.pairid].symbol).substring(0,5)) : 
                 ((this.props.value[this.props.pairid].symbol).substring(0,4))) :
                 (((this.props.value[this.props.pairid].symbol).substring(0,5)))))))}</strong>/
                 {
                 ((((this.props.value[this.props.pairid].symbol).length)===6)? 
                 ((this.props.value[this.props.pairid].symbol).substring(3,6)) : 
                 ((((this.props.value[this.props.pairid].symbol).length)===7) ? 
                 ((((this.props.value[this.props.pairid].symbol).substring(4,7))==="BTC")? 
                 ((this.props.value[this.props.pairid].symbol).substring(4,7)) : 
                 ((this.props.value[this.props.pairid].symbol).substring(3,7))) :
                 (
                 ((((this.props.value[this.props.pairid].symbol).length)===8) ? 
                 ((((this.props.value[this.props.pairid].symbol).substring(5,8))==="BTC")? 
                 ((this.props.value[this.props.pairid].symbol).substring(5,8)) : 
                 ((this.props.value[this.props.pairid].symbol).substring(4,8))) :
                 (((this.props.value[this.props.pairid].symbol).substring(5,9)))))))}
                 </p>
                    <p className={`price ${pricegainloss}`}>
                        {Number(this.props.value[this.props.pairid].lastPrice).toFixed(5)}
                    </p>  
                    <div className={`change ${changegainloss}`}>{(Number(this.props.value[this.props.pairid].priceChangePercent).toFixed(3)) < 0 ? 
                    (this.props.value[this.props.pairid].priceChangePercent).substring(1,6) : (this.props.value[this.props.pairid].priceChangePercent).substring(0,5)
                    }%</div>
                    <p className="volume">{Number(this.props.value[this.props.pairid].quoteVolume).toFixed(3)}</p> 
                    <div><p className="hprice"><strong>High Price:{Number(this.props.value[this.props.pairid].highPrice).toFixed(5)}</strong></p> 
                    <p className="hprice">Low Price{Number(this.props.value[this.props.pairid].lowPrice).toFixed(5)}</p> </div>
                    <div className="action"><button>Trade</button><button className='margin'>Margin</button></div>
                    
                    
           
            </div>
        )
    }
}

export default Datadiv



// WEBPACK FOOTER //
// ./src/Datadiv.js